import {View, TextInput} from 'react-native';
import sy from '~/styles';
import {Pressable, Text, PrimaryButton, Dialog} from '~/components/controls';
import CloseIcon from '~/images/md-icons/close/materialicons/24px.svg';
import SearchIcon from '~/images/md-icons/search/materialicons/24px.svg';
export const SearchHeader = ({title, onClose, closeStyle}) => (
  <View
    style={[
      {height: 64},
      sy['flex-row'],
      sy['border-b'],
      sy['border-gray'],
      sy['items-center'],
    ]}>
    <Pressable style={closeStyle} onPress={onClose}>
      <CloseIcon />
    </Pressable>
    <View style={[sy['flex-1'], sy['justify-center'], sy['mr-14']]}>
      <Text style={[sy['text-center']]}>{title}</Text>
    </View>
  </View>
);
export const SearchQuery = ({prefix, searchTextRef, onChangeText}) => (
  <View
    style={[
      sy['flex-row'],
      sy['p-2'],
      sy['m-4'],
      sy['items-center'],
      {
        borderRadius: 10,
        backgroundColor: '#EBEBEB',
      },
    ]}>
    <SearchIcon
      fill={prefix.length ? '#4A4A49' : '#828282'}
      width={18}
      height={18}
    />
    <TextInput
      ref={(ref) => {
        searchTextRef.current = ref;
        ref?.focus();
      }}
      style={[
        sy.regular,
        sy['flex-1'],
        sy['ml-8'],
        {
          color: prefix?.length > 0 ? '#4A4A49' : '#828282',
        },
      ]}
      placeholder="Zoeken"
      value={prefix}
      onChangeText={onChangeText}
    />
  </View>
);
export const SearchFooter = ({selection, onAdd}) => (
  <View style={[sy['p-4'], sy['flex-row'], sy['justify-end']]}>
    <PrimaryButton
      disabled={!selection?.length}
      onPress={() => onAdd(selection)}>
      Toevoegen
      {selection?.length > 0 ? <>&nbsp;({selection?.length})</> : <></>}
    </PrimaryButton>
  </View>
);
export const DiscardSelectionDialog = ({
  showCancelAddDialog,
  setShowCancelAddDialog,
  onDismiss,
}) => (
  <Dialog
    visible={showCancelAddDialog}
    title="Selectie niet toevoegen?"
    onDismiss={() => setShowCancelAddDialog(false)}
    buttons={[
      {
        text: 'Annuleren',
        onPress: () => setShowCancelAddDialog(false),
      },
      {
        text: 'Niet toevoegen',
        onPress: onDismiss,
      },
    ]}>
    <View style={[sy['py-4']]}>
      <Text>
        Weet je zeker dat je dit venster wil sluiten zonder de selectie toe te
        voegen?
      </Text>
    </View>
  </Dialog>
);
